import script from "./ChatListView.vue?vue&type=script&setup=true&lang=js"
export * from "./ChatListView.vue?vue&type=script&setup=true&lang=js"

import "./ChatListView.vue?vue&type=style&index=0&id=5879d0f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5879d0f2"]])

export default __exports__